// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles-m__grid__2QToJ","issue":"styles-m__issue__82Yi6","slider-stories-wrap":"styles-m__slider-stories-wrap__23r7_","story-card":"styles-m__story-card__XMmXw"};